enum TaskQueue {
    DRAFT = 'draft',
    ACTIVE = 'active',
    BACKLOG = 'backlog',
}

export default TaskQueue;
